import { useContext, useMemo, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import { getRacingTopics } from './common';
import { parseTopic } from './parseTopic';
import { isLogonHigh } from '../../../BetSlip/LoginIBHooks';

const useRacingPush = (contentRef, content) => { 
    const { t } = useTranslation();
    const globalContext = useContext(GlobalContext);
    const { pushState, isRCPushing, resubscribeTopic, pubCacheTopic, clearMessage } = globalContext.mqttClient;
    // const enableOddsPushRef = useRef(globalContext.globalState.commonCtrl.enableOddsPushButton)
    // enableOddsPushRef.current = globalContext.globalState.commonCtrl.enableOddsPushButton && window.globalConfig.RC_ODDS_PUSH
    const isInit = useRef(true)

    useEffect(()=>{
        document.addEventListener("visibilitychange", visibilityChangeRC);
        return () => {
            document.removeEventListener("visibilitychange", visibilityChangeRC);
        }
    },[isRCPushing])

    useEffect(()=>{
        if(content?.meeting ){
            if(isInit.current && isRCPushing){
                resubscribe()
            }
            isInit.current = false
        }
    }, [isRCPushing, content?.meeting])

    const resubscribe = () => {
        if ( isRCPushing ) {
            const topics = getRacingTopics(contentRef.current)
            clearMessage()
            pubHRCacheTipic(topics)
            resubscribeTopic(topics, 'racing');
        }
    }
    const pubHRCacheTipic = (topics) =>{
        let cacheTopics = []
        topics.forEach(topic =>{
            let cacheTopicInfo = parseTopic(topic);
            if(cacheTopicInfo.raceStatus || cacheTopicInfo.displayType == "detail" || (cacheTopicInfo.pmPoolStatus && !cacheTopicInfo.isOdds && !cacheTopicInfo.isPoolInv)){
                cacheTopics.push({
                    recoveryTopic: topic.replace(/\+/g,'*'),
                    requestAllIndicator: 1
                })
            }
            else{
                cacheTopics.push({
                    recoveryTopic: topic.replace(/\+/g,'*'),
                    requestAllIndicator: 0
                })
            }    
        })
        pubCacheTopic(cacheTopics, 'racing')
    }

    const visibilityChangeRC = () =>{ 
        if(!document.hidden){
            resubscribe()
        }
    }
    useEffect(()=> {
        if ( isRCPushing && (!isInit.current || !window.globalConfig.RC_ODDS_PUSH_NO_LOGIN)) {
            resubscribe();
            isInit.current = false
        }
    }, [isRCPushing, content.venue])

    useEffect(()=>{
        if ( isRCPushing && (!isInit.current || !window.globalConfig.RC_ODDS_PUSH_NO_LOGIN) ) {
            resubscribe();
        }
    },[isRCPushing, content.displayOpt, content.displayOpt2])


    const topicInfo = useMemo(()=> {parseTopic(pushState.current.topic)}, [pushState.current.topic])

    return {
        topic: pushState.current.topic,
        message: pushState.current.message,
        topicInfo,
        isPushing: isRCPushing,
        resubscribe
    };
    
}

export default useRacingPush